// extracted by mini-css-extract-plugin
module.exports = {"iconDotLoader":"ucrmm","dot":"-3s-i","iconDotLoader_inline":"dGWKR","loader":"_6MUzS"};